import { DateInput, SelectInput, TextInput } from "react-admin";
import { SABIL_TYPE_OPTIONS } from "@/constants";
import ReceiptFilterLiveForm, {
  receiptFilterCompactInputProps,
  receiptFilterDateFieldSx,
} from "@/components/receipt-filters/ReceiptFilterLiveForm";
import { SABIL_RECEIPT_FILTER_FIELDS } from "./sabil-receipt-filter-fields";

const PAYMENT_MODE_CHOICES = [
  { id: "CASH", name: "CASH" },
  { id: "ONLINE", name: "ONLINE" },
  { id: "CHEQUE", name: "CHEQUE" },
];

const [sabilTypeField, paymentModeField, searchField, startDateField, endDateField] =
  SABIL_RECEIPT_FILTER_FIELDS;

/**
 * Renders inside <List> and syncs to the list query via FilterLiveForm + useListContext.
 */
export default function SabilReceiptFilterBar() {
  return (
    <ReceiptFilterLiveForm>
      <SelectInput
        source={sabilTypeField.source}
        label={sabilTypeField.label}
        choices={SABIL_TYPE_OPTIONS}
        emptyText="All"
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 160 } }}
      />
      <SelectInput
        source={paymentModeField.source}
        label={paymentModeField.label}
        choices={PAYMENT_MODE_CHOICES}
        emptyText="All modes"
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 140 } }}
      />
      <TextInput
        source={searchField.source}
        label={searchField.label}
        resettable
        {...receiptFilterCompactInputProps}
        sx={{ minWidth: { sm: 200 }, flex: { sm: "1 1 200px" }, maxWidth: { sm: 360 } }}
      />
      <DateInput
        source={startDateField.source}
        label={startDateField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
      <DateInput
        source={endDateField.source}
        label={endDateField.label}
        {...receiptFilterCompactInputProps}
        sx={receiptFilterDateFieldSx}
      />
    </ReceiptFilterLiveForm>
  );
}
